import moment from "moment-timezone";
import gql from "graphql-tag";

import { Company } from "../../../../types";
import UPDATE_DOCUMENT_MUTATION from "../../graphql/document/UpdateDocument.gql";
import CHECK_DOUBLON_DOCUMENT from "../../graphql/document/CheckDoublonDocument.gql";

import { createCompany } from "../../services/companyServices";
import { getAmountSign, updateAmountSigned } from "../../services/documentServices";

import { Apollo } from "@/decorators";
import {
    getAccountableAccount,
    getConnectAccountableAccount,
} from "@/services/accountableAccountServices";
import { getDBFormattedDate } from "@/services/dateServices";
import { isNotSubjectToVAT } from "@/services/vat/vatHelpers.services";
import CompanyTableComponent from "../admin/CompaniesTable.vue";
import Chat from "../chat/Chat.vue";
import SelectUser from "../user/SelectUser.vue";
import { DocumentValidationBase } from "./DocumentValidationBase";

import { isInsideClosedAccountingPeriod } from "../../services/accountingPeriods";
import { isAccountingZero, mathFix, minAuthorizeDiff } from "../../services/mathServices";
import { vatListDocument, vatListDocumentDiscount } from "../../services/vatServices";
import { Component } from "vue-facing-decorator";
import { Watch } from "vue-facing-decorator";
import { getNextNoValidatedDocumentId } from "./DocumentValidationSpeedRun.helper";

@Component({
    components: {
        companyTable: CompanyTableComponent,
        Chat,
        SelectUser,
    },
})
export class DocumentValidationInvoiceBase extends DocumentValidationBase {
    get advice() {
        return "valider le document";
    }

    lockFieldSync = false;

    valid = false;

    validated = false;

    loading = false;

    updating = false;

    dialogSelectCompany = false;

    userActivityStartDateFormat = moment().format();
    userActivityStartDateDocumentValidation = moment(this.userActivityStartDateFormat);

    withDeposit = false;

    withSubGrossAmounts: boolean = false;

    deposit = {
        amountSigned1: 0.0,
        amountSigned2: 0.0,
    };

    //
    // consumer company
    //

    // get vatList() {
    //     const vats = [{ value: "20", text: '20' },
    //             // { value: "20OIL_PRODUCTS", text: '20 - Produits pétroliers' },
    //             // { value: "20ENERGY_DELIVERIES", text: "20 - Livraisons d'énergie" },
    //             { value: "10", text: '10' },
    //             { value: "8.5", text: '8.5' },
    //             { value: "5.5", text: '5.5' },
    //             { value: "2.1", text: '2.1' },
    //             { value: "0", text: '0 - Inconnue', disabled: true },
    //             { value: "0NO_VAT_TYPE", text: '0 - Aucun' },
    //             { value: "0INTRACOM", text: '0 - Intracom' }]
    //     if (this.document.type === "SALES_INVOICE") {
    //             vats.push({ value: "0EXPORT", text: '0 - Export' })
    //     } else {
    //             vats.push({ value: "0IMPORT", text: '0 - Import' })
    //     }
    //     vats.push({ value: "0REVERSE_CHARGE", text: '0 - Autoliquidation' })
    //     if (this.document.type !== "SALES_INVOICE") {
    //         vats.push({ value: 'custom', text: 'Libre' })
    //     }

    //     return vats
    // }

    get vatList() {
        return vatListDocument(this.document.type);
    }

    get isInvoiceNumberManadatory() {
        return this.document.type === "SALES_INVOICE";
    }

    // get vatListDiscount() {
    //     if (this.document.type !== "SALES_INVOICE") {
    //         return [{ value: "20", text: '20' },
    //             { value: "10", text: '10', disabled: true },
    //             { value: "8.5", text: '8.5', disabled: true },
    //             { value: "5.5", text: '5.5', disabled: true },
    //             { value: "2.1", text: '2.1', disabled: true },
    //             { value: "0", text: '0 - Inconnue', disabled: true },
    //             { value: "0NO_VAT_TYPE", text: '0 - Aucun' },
    //             { value: "0INTRACOM", text: '0 - Intracom', disabled: true },
    //             { value: "0EXPORT", text: '0 - Export', disabled: true },
    //             { value: "0IMPORT", text: '0 - Import', disabled: true },
    //             { value: "0REVERSE_CHARGE", text: '0 - Autoliquidation', disabled: true },
    //             { value: 'custom', text: 'Libre' }]
    //     }
    //     return [{ value: "20", text: '20' }, { value: "10", text: '10' },{ value: "8.5", text: '8.5' }, { value: "5.5", text: '5.5' }, { value: "2.1", text: '2.1' }, { value: "0", text: '0' }]
    // }

    get vatListDiscount() {
        return vatListDocumentDiscount(this.document.type);
    }

    @Apollo(
        {
            query: gql`
                query consumerCompany {
                    companies(where: { type: CONSUMER }) {
                        id
                        name
                    }
                }
            `,
            skip() {
                return (
                    !this.currentUser ||
                    !this.currentUser.id ||
                    !this.document ||
                    this.document.type !== "SALES_INVOICE"
                );
            },
        },
        (data) => (data && data.companies && data.companies.length ? data.companies[0] : null),
    )
    consumerCompany: Company = null;

    get consumer() {
        return (
            this.document.thirdPartyCompany &&
            this.consumerCompany &&
            this.document.thirdPartyCompany.id === this.consumerCompany.id
        );
    }

    set consumer(value) {
        if (value) {
            this.document.thirdPartyCompany = this.consumerCompany;
        } else {
            this.document.thirdPartyCompany = null;
        }
    }

    get documentTypes() {
        const documentTypes = [];
        if (this.document.type !== "EXPENSE_REPORT_DOCUMENT") {
            documentTypes.push({
                label: this.$t("document.type.PURCHASE_INVOICE"),
                value: "PURCHASE_INVOICE",
            });
            if (this.declareSalesInvoices) {
                documentTypes.push({
                    label: this.$t("document.type.SALES_INVOICE"),
                    value: "SALES_INVOICE",
                });
            }
            const reconciliationType =
                this.legalForm !== "EI" ? "CURRENT_ACCOUNT" : "OPERATOR_ACCOUNT";
            documentTypes.push({
                label: this.$t("document.type." + reconciliationType),
                value: reconciliationType,
            });
            documentTypes.push({
                label: this.$t("document.type.MISCELLANEOUS"),
                value: "MISCELLANEOUS",
            });
        } else {
            documentTypes.push({
                label: this.$t("document.type.EXPENSE_REPORT_DOCUMENT"),
                value: "EXPENSE_REPORT_DOCUMENT",
            });
        }

        return documentTypes;
    }

    get subjectToVAT() {
        return !isNotSubjectToVAT(this.selectedCompany.vatSystem);
    }

    get showDeposit() {
        if (isNotSubjectToVAT(this.selectedCompany.vatSystem)) return false;
        if (this.document.type === "EXPENSE_REPORT_DOCUMENT") return false;
        if (this.document.type === "CURRENT_ACCOUNT") return false;
        if (this.document.type === "OPERATOR_ACCOUNT") return false;
        return true;
    }

    get dateList() {
        const dateList = [];
        this.svgVariants.forEach((variant) => {
            if (variant.type === "DATE") dateList.push(this.formatDate(variant.value));
        });
        return dateList;
    }

    get invoiceNumberList() {
        const invoiceNumberList = [];
        this.svgVariants.forEach((variant) => {
            if (variant.type === "INVOICENUMBER") invoiceNumberList.push(variant.value);
        });
        return invoiceNumberList;
    }

    get foundCompanies() {
        if (this.analysis?.companies2) {
            return this.analysis.companies2;
        }
        return null;
    }

    get disabledMultiVat() {
        if (this.document.type === "SALES_INVOICE") {
            return this.multiAccountableAccount;
        }
        return false;
    }

    get multiVat() {
        if (!this.subjectToVAT) {
            return false;
        }
        return this.document.multiVat;
    }

    set multiVat(data) {
        if (!this.subjectToVAT) {
            return;
        }
        this.document.multiVat = data;
        if (this.document.multiVat) {
            this.form.single_prices.prices.vatRate.value = "custom";
            this.form.single_prices.prices.link = true;
            while (this.form.subAmounts.length < 2) {
                this.addNewSubAmount();
            }
        }
        this.syncAccountableAccount();
    }

    //
    // multiAccountableAccount
    //

    multiAccountableAccount_: boolean = false;

    get multiAccountableAccount() {
        return this.multiAccountableAccount_;
    }

    set multiAccountableAccount(data) {
        if (data && this.document.type === "SALES_INVOICE") {
            this.multiVat = true;
        }

        if (data) {
            while (data && this.form.subAmounts.length < 2) {
                this.addNewSubAmount();
            }
        }
        this.multiAccountableAccount_ = data;
        this.syncAccountableAccount();
    }

    syncAccountableAccount() {
        if (this.multiAccountableAccount || this.multiVat) {
            while (this.form.subAmounts.length < 2) {
                this.addNewSubAmount();
            }
        }
        // else if (!this.multiAccountableAccount && !this.multiVat) {
        //     this.form.subAmounts.splice(0, this.form.subAmounts.length)
        // }
    }

    updateMultiAccountableAccount() {
        this.multiAccountableAccount = this.form?.subAmounts?.length >= 2;
        // let aa
        // if (this.form.subAmounts.length) {
        //     for (const subAmountData of this.form.subAmounts) {
        //         if (!aa) {
        //             aa = subAmountData.accountableAccount.name
        //             continue
        //         }
        //         if (aa !== subAmountData.accountableAccount.name) {
        //             this.multiAccountableAccount = true
        //             return
        //         }

        //     }
        // }
        // this.multiAccountableAccount = false
    }

    confidence(meta: any) {
        if (!meta) return null;
        return Math.round(meta.confidence * 100) || null;
    }

    dateDialog: boolean = false;
    // date:string = ""

    onDateChangeFromDatePicker() {
        if (this.form && this.form.date) {
            if (this.form.date.value) {
                this.form.date.validated = true;
            } else {
                this.form.date.validated = false;
            }
        }
    }

    async companySelected(obj: Company) {
        // console.log(obj);
        if (obj.id) {
            (this.document.thirdPartyCompany as any) = obj;
            this.dialogSelectCompany = false;
        } else {
            obj.id = await createCompany(this.$apollo, obj);
            (this.document.thirdPartyCompany as any) = obj;
            this.dialogSelectCompany = false;
        }
    }

    findPriceGroup(propertyName: string) {
        const prices = ["netAmount", "grossAmount", "vatAmount", "vatRate"];

        if (prices.find((el) => el === propertyName))
            return { group: this.form.single_prices.prices, suffix: "" };
        for (let index = 1; index <= 3; index++) {
            const prices = [
                "netAmount_" + index,
                "vatAmount_" + index,
                "grossAmount_" + index,
                "vatRate_" + index,
            ];

            if (prices.find((el) => el === propertyName)) {
                const subAmountData = this.form.subAmounts.find((sa) => sa.index == index);
                if (subAmountData) {
                    return { group: subAmountData, suffix: "" };
                }
            }
        }
        return null;
    }

    onFieldAssociation(selectedField: any, propertyName: string) {
        this.cleanVariant(selectedField);
        selectedField.index = this.activePolygon.index;
        this.svgVariants[selectedField.index].active = true;
        selectedField.value =
            this.svgVariants[selectedField.index].type === "NUMBER" ||
            this.svgVariants[selectedField.index].type === "PERCENTAGE"
                ? +parseFloat(this.svgVariants[selectedField.index].value)
                : this.svgVariants[selectedField.index].value;
        selectedField.validated = true;
        this.associatedFields.fields = {};
        this.hideVariantList();
        this.zoomManager.resetZoom();
        if (["PRICE", "PERCENTAGE"].includes(this.svgVariants[selectedField.index].type)) {
            const result = this.findPriceGroup(propertyName);
            this.onMetadataChange(result.group, result.suffix, propertyName);
        }
    }

    searchInPolygon(key, valueData, list) {
        this.activePolygon.fieldNames.forEach((field) => {
            if (field.name === key) list[key] = valueData;
        });
    }

    updateAssociatedFieldsList() {
        const list = {};
        // console.log(this.activePolygon)
        if (!this.activePolygon) return;
        Object.keys(this.form).forEach((k1) => {
            if (["single_prices"].includes(k1)) {
                Object.keys(this.form[k1]).forEach((k2) => {
                    Object.keys(this.form[k1][k2]).forEach((k3) => {
                        this.searchInPolygon(k3, this.form[k1][k2][k3], list);
                    });
                });
            } else if (k1 === "subAmounts") {
                for (const subAmountData of this.form.subAmounts) {
                    if (subAmountData.index) {
                        this.searchInPolygon(
                            "netAmount" + subAmountData.index,
                            subAmountData.netAmount,
                            list,
                        );
                        this.searchInPolygon(
                            "vatAmount" + subAmountData.index,
                            subAmountData.vatAmount,
                            list,
                        );
                        this.searchInPolygon(
                            "grossAmount" + subAmountData.index,
                            subAmountData.grossAmount,
                            list,
                        );
                        this.searchInPolygon(
                            "vateRate" + subAmountData.index,
                            subAmountData.vatRate,
                            list,
                        );
                    }
                }
            } else {
                this.searchInPolygon(k1, this.form[k1], list);
            }
        });
        this.associatedFields.fields = list;
    }

    initSubNetAmount() {
        //
        // DEPRECATED
        //
        debugger;
        return;
    }

    showVATType() {
        if (this.multiVat) {
            for (const subAmountData of this.form.subAmounts) {
                if (subAmountData.vatRate.value === 0) {
                    return true;
                }
            }
            return false;
        }
        return this.form.single_prices.prices.vatRate.value === 0;
    }

    toggleFieldSync(prices: string, index) {
        // deprecated user toggleLink instead
        debugger;
    }

    toggleLink(amountData) {
        if (amountData.vatRate.value === "custom") {
            return;
        }
        if (!amountData) {
            return;
        }
        amountData.link = !amountData.link;
        if (amountData.link) {
            this.onMetadataChange_amountData(amountData, "vatRate");
        }
        this.$forceUpdate();
    }

    areRowPricesValidated(priceType: any, suffix: string) {
        // deprecated use areRowPricesValidated_amountData instead
        debugger;
        return true;
    }

    areRowPricesValidated_amountData(amountData, mainPrice) {
        const netAmount = amountData.netAmount.value;
        const vatAmount = amountData.vatAmount.value;
        const grossAmount = amountData.grossAmount.value;
        const vatRate = amountData.vatRate.value;

        if (!this.subjectToVAT) {
            const diff = grossAmount - netAmount;
            if (Math.abs(diff) >= minAuthorizeDiff) {
                return false;
            }
            return true;
        }

        if (netAmount === null || vatAmount === null || grossAmount === null || vatRate === null) {
            return false;
        }

        if (this.multiAccountableAccount && !this.multiVat && !amountData.total) {
            return true;
        }

        if (netAmount === 0 && vatAmount === 0 && grossAmount === 0) {
            if (mainPrice) {
                if (this.deposit && (this.deposit.amountSigned1 || this.deposit.amountSigned2)) {
                    return true;
                }
            }
            return false;
        }

        const diff = netAmount + vatAmount - grossAmount;
        // console.log(diff)
        if (Math.abs(diff) >= minAuthorizeDiff) {
            return false;
        }

        if (netAmount > grossAmount) {
            return false;
        }
        // if ((!this.multiVat || !amountData.total ) && vatRate !== "custom") {
        //     const vrDiff = parseFloat(vatRate) / 100 - (grossAmount / netAmount - 1);
        //     if (Math.abs(vrDiff) >= minAuthorizeDiff) {
        //         return false;
        //     }
        // }

        return true;
    }

    priceTextColor(priceType: any, suffix: string) {
        // deprecated use priceTextColor_amountData instead
        debugger;
        return "";
    }

    priceTextColor_amountData(amountData, mainPrice) {
        return this.areRowPricesValidated_amountData(amountData, mainPrice) ? "" : "red";
    }

    get arePricesValidated() {
        if (!this.subjectToVAT) {
            if (this.multiAccountableAccount) {
                let total = 0;
                for (const subAmountData of this.form.subAmounts) {
                    total += subAmountData.netAmount.value;
                }
                const diff = this.form.single_prices.prices.grossAmount.value - total;
                if (Math.abs(diff) >= minAuthorizeDiff) {
                    return false;
                }
            }
            return !!this.form.single_prices.prices.grossAmount.value;
        }
        if (!this.areRowPricesValidated_amountData(this.form.single_prices.prices, true))
            return false;
        if (this.multiVat) {
            for (const subAmountData of this.form.subAmounts) {
                if (!this.areRowPricesValidated_amountData(subAmountData, false)) {
                    return false;
                }
            }
            let netAmount = 0;
            let vatAmount = 0;
            let grossAmount = 0;
            for (const subAmountData of this.form.subAmounts) {
                let sign = 1;
                if (subAmountData.sign === -1) {
                    sign = -1;
                }
                if (subAmountData.netAmount.value) {
                    netAmount += sign * subAmountData.netAmount.value;
                }
                if (subAmountData.vatAmount.value) {
                    vatAmount += sign * subAmountData.vatAmount.value;
                }
                if (subAmountData.grossAmount.value) {
                    grossAmount += sign * subAmountData.grossAmount.value;
                }
            }
            if (Math.abs(this.form.single_prices.prices.netAmount.value - netAmount) > 1e-3)
                return false;
            if (Math.abs(this.form.single_prices.prices.vatAmount.value - vatAmount) > 1e-3)
                return false;
            if (Math.abs(this.form.single_prices.prices.grossAmount.value - grossAmount) > 1e-3)
                return false;
        } else if (this.multiAccountableAccount) {
            let netAmount = 0;
            for (const subAmountData of this.form.subAmounts) {
                let sign = 1;
                if (subAmountData.sign === -1) {
                    sign = -1;
                }
                if (subAmountData.netAmount.value) {
                    netAmount += sign * subAmountData.netAmount.value;
                } else {
                    return false;
                }
            }
            if (Math.abs(this.form.single_prices.prices.netAmount.value - netAmount) > 1e-3)
                return false;
        }
        return true;
    }

    onPricesValidation() {
        if (this.form.allPricesValidated) {
            this.form.allPricesValidated = false;
        } else if (this.arePricesValidated) {
            this.form.allPricesValidated = true;
        }
    }

    buildMetadataWithValue(value) {
        const result = {
            value: value,
            validatedValue: null,
            validated: false,
            index: null,
        };
        return result;
    }

    buildMetadata(document: any, key: string, valueType = "number", value = undefined) {
        const internalValue = value !== undefined ? value : document[key];
        document[`${key}_variants`] = [];
        let variantIndex = null;
        if (this.analysis) {
            if (key && this.analysis.results[key.toUpperCase()]) {
                this.analysis.results[key.toUpperCase()].variants.forEach((val) => {
                    // val.confidence *= 100
                    document[`${key}_variants`].push(val);
                });

                document[`${key}_variants`].forEach((variant) => {
                    this.svgVariants[variant.index].fieldNames.push({
                        name: key,
                        confidence: variant.confidence,
                    });
                });

                const coordinates = [];
                const variant =
                    this.analysis.values[
                        this.analysis.results[key.toUpperCase()].variants[
                            this.analysis.results[key.toUpperCase()].variantIndex
                        ].index
                    ];
                if (variant.boxes.length > 0) {
                    variant.boxes.forEach((box) => {
                        if (box.vertices.length > 0) coordinates.push(box.vertices);
                    });
                }

                document[`${key}_coordinates`] = coordinates;
                // variantIndex = this.analysis.results[key.toUpperCase()].variantIndex
                variantIndex = document[`${key}_coordinates`]
                    ? this.svgVariants.findIndex((elem: any) => {
                          if (valueType === "number") return +elem.value === +internalValue;
                          if (valueType === "date") {
                              // console.log(elem.value === moment(internalValue).format("YYYY-MM-DD"), elem.value, moment(internalValue).format("YYYY-MM-DD"))
                              return elem.value === moment(internalValue).format("YYYY-MM-DD");
                          }
                          return elem.value === internalValue;
                      })
                    : null;
                // if (key === "date") { console.log("variant index", variantIndex) }
            }
        }
        let valueDefined = null;

        // Must be non valid if empty string
        if (["invoiceNumber"].includes(key)) {
            valueDefined = internalValue;
        } else {
            valueDefined = internalValue !== null && internalValue !== undefined;
        }

        const result = {
            // value: valueDefined ? document[`${key}`] : document[`${key}Auto`],
            value: internalValue,
            validatedValue: valueDefined ? internalValue : null,
            validated: valueDefined,
            // ||
            // (document[`${key}_confidence`] !== null &&
            //     document[`${key}_confidence`] > 90),
            index: variantIndex,
        };
        if (
            result.value === null &&
            key.startsWith("vatRate") &&
            this.document.type !== "SALES_INVOICE"
        ) {
            result.value = "custom";
        } else if (
            key.startsWith("vatRate") &&
            (result.value === null || result.value === undefined)
        ) {
            result.value = "custom";
        }
        return result;
    }

    beforeMount() {
        this.onDocumentChanged(this.inDocument.id, undefined);
    }

    @Watch("multiVat")
    onMultiVatChanged(next, prev) {
        if (!this.arePricesValidated && this.form.allPricesValidated) {
            this.form.allPricesValidated = false;
        }
    }

    @Watch("documentId")
    async onDocumentChanged(prev, next) {
        if (prev !== next) {
            if (this.inDocument) {
                await this.getAnalysis();
                this.wizardStep = 1;
                if (this.inDocument.type === "EXPENSE_REPORT_DOCUMENT") {
                    this.wizardStep = 3;
                }
                if (
                    !this.inDocument.accountableAccount &&
                    !this.document.data?.subAmounts?.length
                ) {
                    const aaName = this.defaultAccountableAccount;
                    if (aaName) {
                        this.inDocument.accountableAccount =
                            getAccountableAccount(this.$store, aaName) || null;
                    }
                }
                this.validated = false;
                this.clearVariantList();
                this.updateForm(this.inDocument);
                if (this.document.signedUrl && !this.isPDF) {
                    this.zoomManager.instanciateSvgZoom(this.svgSuffix);
                }

                this.finishMounted();
            } else {
                console.error("inDocument is undefined");
            }
        }
    }

    get disabledValidate() {
        if (!this.valid || !this.form.allPricesValidated) {
            return true;
        }

        if (this.documentIsInAccountingClosing) {
            if (isInsideClosedAccountingPeriod(this.$store, this.accountingDate)) {
                return true;
            }
        }

        let subAmounts = this.form.subAmounts; // 488603 - 604
        if (this.form.subAmounts.length && this.multiAccountableAccount) {
            const startNumberAccountableAccount =
                this.document.type !== "SALES_INVOICE" ? ["6", "2"] : ["7"];
            for (const suAmountData of subAmounts) {
                if (!suAmountData.accountableAccount) {
                    return true;
                }
                if (
                    suAmountData.accountableAccount.name?.startsWith("409600") ||
                    suAmountData.accountableAccount.name?.startsWith("488")
                ) {
                    continue;
                }
                const firstCharacter = suAmountData.accountableAccount.name.substring(0, 1);
                if (startNumberAccountableAccount.indexOf(firstCharacter) === -1) {
                    return true;
                }
            }
        }

        if (this.isAccountingUser && !this.multiAccountableAccount) {
            if (!this.document.accountableAccount?.name) {
                return true;
            }
        }

        if (this.withSubGrossAmounts) {
            const subGrossAmounts = this.form.subGrossAmounts;
            if (subGrossAmounts?.length) {
                let sumOfSubPayements = subGrossAmounts.reduce((acc, cur) => {
                    return acc + cur.amount;
                }, 0);
                const sign = getAmountSign(this.document);
                sumOfSubPayements = -sign * sumOfSubPayements;
                if (!isAccountingZero(sumOfSubPayements - this.grossAmountSigned)) {
                    return true;
                }
                // debugger
                if (
                    !subGrossAmounts.every((x) => {
                        return !!x.accountableAccount?.name;
                    })
                ) {
                    return true;
                }
            }
        }

        // if ((!this.isBankTransactionReceipt && !this.isIncomingOutgoingPayment && !this.document.thirdPartyCompany?.id)) return true;
        if (!this.isBankTransactionReceipt && !this.isIncomingOutgoingPayment) {
            if (
                this.document.type !== "EXPENSE_REPORT_DOCUMENT" &&
                !this.document.thirdPartyCompany?.id
            ) {
                return true;
            }
        }
        // console.log(this.document.type)
        if (
            this.document.type === "SALES_INVOICE" &&
            (!this.form.invoiceNumber.value || this.form.invoiceNumber.value.length === 0)
        ) {
            return true;
        }
        if (!this.arePricesValidated) {
            return true;
        }
        return !this.form.allPricesValidated;
    }

    get grossAmountSigned() {
        if (
            this.form.single_prices &&
            this.form.single_prices.prices &&
            this.form.single_prices.prices.grossAmount
        ) {
            const sign = getAmountSign(this.document);
            const grossAmount = parseFloat(this.form.single_prices.prices.grossAmount.value);
            let grossAmountSigned = -sign * grossAmount;
            if (this.withDeposit) {
                if (this.deposit.amountSigned1) {
                    grossAmountSigned += -sign * this.deposit.amountSigned1;
                }
                if (this.deposit.amountSigned2) {
                    grossAmountSigned += -sign * this.deposit.amountSigned2;
                }
            }
            return grossAmountSigned;
        }
        return this.document.grossAmountSigned;
    }

    get netAmountSigned() {
        if (
            this.form.single_prices &&
            this.form.single_prices.prices &&
            this.form.single_prices.prices.netAmount
        ) {
            let netAmount = 0.0;
            if (
                this.form.single_prices.prices.netAmount.validated &&
                this.form.single_prices.prices.netAmount.validatedValue !== null &&
                !isNaN(this.form.single_prices.prices.netAmount.validatedValue)
            ) {
                netAmount = parseFloat(this.form.single_prices.prices.netAmount.validatedValue);
            } else if (
                this.form.single_prices.prices.netAmount.value !== null &&
                !isNaN(this.form.single_prices.prices.netAmount.value)
            ) {
                netAmount = parseFloat(this.form.single_prices.prices.netAmount.value);
            }
            const sign = getAmountSign(this.document);
            return sign * netAmount;
        }
        return this.document.netAmountSigned;
    }

    get toUpdateDate() {
        return this.form.date ? getDBFormattedDate(this.form.date.value) : null;
    }

    async onFormValidation() {
        // const form = this.form;
        // @ts-ignore
        if (!this.$refs.form?.validate()) {
            debugger;
            return;
        }
        this.updating = true;

        const localDoc = {
            type: this.document.type,
            displayName: this.document.displayName,

            creditNote: this.document.creditNote,
            vatType: null,
            // netAmount: parseFloat(this.form.single_prices.prices.netAmount.value),
            // vatAmount: parseFloat(this.form.single_prices.prices.vatAmount.value),
            netAmount: null,
            vatAmount: null,
            grossAmount: parseFloat(this.form.single_prices.prices.grossAmount.value),
            netAmountSigned: null,
            vatAmountSigned: null,
            grossAmountSigned: 0,
        };
        // if (this.subjectToVAT) {
        localDoc.vatType = this.showVATType() ? this.form.single_prices.prices.vatType : null;
        localDoc.netAmount = parseFloat(this.form.single_prices.prices.netAmount.value);
        localDoc.vatAmount = parseFloat(this.form.single_prices.prices.vatAmount.value);
        // } else {
        //     localDoc.netAmount = parseFloat(this.form.single_prices.prices.grossAmount.value);
        // }
        updateAmountSigned(localDoc);
        localDoc.grossAmountSigned = this.grossAmountSigned;
        localDoc.grossAmount = Math.abs(localDoc.grossAmountSigned);

        // if (!this.spreadPurchaseDialog && localDoc.type === "PURCHASE_INVOICE" && localDoc.grossAmountSigned < -1000) {
        //     // if (!this.spreadStartDate) {
        //     this.spreadStartDate = this.form.date ? this.form.date.value : "";
        //     // }
        //     if (this.spreadStartDate) {
        //         this.spreadMinStartDate = moment(this.spreadStartDate).add(-1, "months").utc(true).format();
        //         this.spreadMaxStartDate = moment(this.spreadStartDate).add(6, "months").utc(true).format();
        //     } else {
        //         this.spreadMinStartDate = ""
        //         this.spreadMaxStartDate = ""
        //     }
        //     this.spreadPurchaseDialog = true;
        //     return;
        // }
        //
        // DO NOT MOVE LOADING
        //
        this.loading = true;

        let data = null;
        if (this.inDocument.data) {
            data = JSON.parse(JSON.stringify(this.inDocument.data));
        }
        if (this.activateSpreadAmount) {
            if (!data) {
                data = {
                    spreading: {
                        startDate: "",
                        mounthCount: 0,
                    },
                };
            } else if (!data.spreading) {
                data.spreading = {
                    startDate: "",
                    mounthCount: 0,
                };
            }
            data.spreading.startDate = this.spreadStartDate;
            data.spreading.mounthCount = this.spreadMounthCount;
        } else if (data && data.spreading) {
            delete data.spreading;
        }

        const sign = getAmountSign(this.document);

        if (this.withDeposit && (this.deposit.amountSigned1 || this.deposit.amountSigned2)) {
            if (!data) {
                data = {};
            }
            this.deposit.amountSigned1 = sign * this.deposit.amountSigned1 || 0.0;
            this.deposit.amountSigned2 = sign * this.deposit.amountSigned2 || 0.0;
            data.deposit = this.deposit;
        } else if (data && data.deposit) {
            delete data.deposit;
        }

        // data = this.streamSubNetAmonts(data)

        let accountableAccount;
        let multiAccountableAccount = this.multiAccountableAccount;
        // update document accountableAccount if necessary
        if (multiAccountableAccount) {
            let differenceFound = false;
            let aa;
            for (const subAmountData of this.form.subAmounts) {
                if (!aa) {
                    aa = subAmountData.accountableAccount;
                    continue;
                }
                if (subAmountData.accountableAccount.name != aa) {
                    differenceFound = true;
                    break;
                }
            }
            if (!differenceFound) {
                multiAccountableAccount = false;
                if (aa) {
                    accountableAccount = await getConnectAccountableAccount(
                        this.$store,
                        this.$apollo,
                        aa,
                    );
                }
            } else if (this.document.accountableAccount) {
                accountableAccount = { disconnect: true };
            }
        } else {
            this.document.accountableAccount = await getConnectAccountableAccount(
                this.$store,
                this.$apollo,
                this.document.accountableAccount?.name,
                true,
                this.document.accountableAccount?.description,
            );
        }
        // update subAmounts
        const subAmounts = [];
        if (this.multiAccountableAccount || this.multiVat) {
            for (const subAmountData of this.form.subAmounts) {
                let saSign = 1;
                if (subAmountData.sign === -1) {
                    saSign = -1;
                }
                const sa: any = {
                    link: subAmountData.link,
                    netAmountSigned: sign * saSign * subAmountData.netAmount.value,
                    stockOperation: subAmountData.stockOperation || undefined,

                    // vatAmountSigned: sign * saSign * subAmountData.vatAmount.value,
                    // grossAmountSigned: -sign * saSign * subAmountData.grossAmount.value,
                    // vatRate: null
                };
                if (this.multiVat) {
                    (sa.vatAmountSigned = sign * saSign * subAmountData.vatAmount.value),
                        (sa.grossAmountSigned = -sign * saSign * subAmountData.grossAmount.value),
                        (sa.vatRate = null);
                    if (subAmountData.vatRate.value !== "custom") {
                        sa.vatRate = subAmountData.vatRate.value;
                        if (subAmountData.vatRate.value === 0) {
                            sa.vatType = subAmountData.vatType;
                        }
                    }
                }
                if (subAmountData.index !== undefined) {
                    sa.index = subAmountData.index;
                }
                if (multiAccountableAccount) {
                    sa.accountableAccount = subAmountData.accountableAccount.name;
                }

                if (subAmountData.sign === -1) {
                    sa.type = subAmountData.sign;
                }
                subAmounts.push(sa);
            }
        }
        if (subAmounts.length) {
            if (!data) {
                data = {};
            }
            data.subAmounts = subAmounts;
        } else if (data && data.subAmounts) {
            delete data.subAmounts;
        }

        let subGrossAmounts;
        if (this.withSubGrossAmounts) {
            subGrossAmounts = this.form.subGrossAmounts.map((sga) => ({
                accountableAccount: sga.accountableAccount.name,
                amount: -sign * sga.amount,
                dueDate: sga.dueDate || undefined,
            }));
        }
        if (subGrossAmounts?.length) {
            if (!data) {
                data = {};
            }
            data.subGrossAmounts = subGrossAmounts;
        } else if (data && data.subGrossAmounts) {
            delete data.subGrossAmounts;
        }

        if (this.stockOperation) {
            if (!data) {
                data = {};
            }
            data.stockOperation = this.stockOperation;
        }

        if (data) {
            const keys = Object.keys(data);
            if (!keys.length) {
                data = null;
            }
        }
        let thirdPartyAccountableAccount = this.document.thirdPartyAccountableAccount?.name || null;
        if (!thirdPartyAccountableAccount) {
            if (this.document.type === "PURCHASE_INVOICE") {
                thirdPartyAccountableAccount = "401000";
            } else if (this.document.type === "SALES_INVOICE") {
                thirdPartyAccountableAccount = "411000";
            }
        }

        const variables = {
            documentId: this.documentId,
            displayName: localDoc.displayName,
            owner: this.currentAccountUser.id
                ? { connect: { id: this.currentAccountUser.id } }
                : undefined,
            type: localDoc.type || null,
            creditNote: localDoc.creditNote,
            vatType: localDoc.vatType,
            multiVat: this.multiVat,
            status: "VALIDATED",
            date: this.toUpdateDate,
            dueDate:
                this.dueDateEnable && this.dueDate ? getDBFormattedDate(this.dueDate) : undefined,
            accountingDate:
                (this.documentIsInAccountingClosing && getDBFormattedDate(this.accountingDate)) ||
                null,
            invoiceNumber: this.form.invoiceNumber ? this.form.invoiceNumber.value : null,

            data: data,
            // amounts

            grossAmount: localDoc.grossAmount,
            grossAmountSigned: localDoc.grossAmountSigned,

            netAmount: null,
            netAmountSigned: null,
            vatAmount: null,
            vatAmountSigned: null,
            vatRate: null,
            vatAmount1: null,
            netAmount1: null,
            grossAmount1: null,
            vatRate1: null,
            vatAmount2: null,
            netAmount2: null,
            grossAmount2: null,
            vatRate2: null,
            vatAmount3: null,
            netAmount3: null,
            grossAmount3: null,
            vatRate3: null,

            thirdPartyCompany: this.document.thirdPartyCompany
                ? { connect: { id: this.document.thirdPartyCompany.id } }
                : undefined,
            thirdPartyAccountableAccount: await getConnectAccountableAccount(
                this.$store,
                this.$apollo,
                thirdPartyAccountableAccount,
            ),
            accountableAccount: accountableAccount,
            // accountableAccountAuto: accountableAccountAuto
        };

        if (this.subjectToVAT) {
            variables.netAmount = localDoc.netAmount;
            variables.netAmountSigned = localDoc.netAmountSigned;
            variables.vatAmount = localDoc.vatAmount;
            variables.vatAmountSigned = localDoc.vatAmountSigned;
            if (!this.multiVat) {
                variables.vatRate =
                    this.form.single_prices.prices.vatRate.value !== "custom"
                        ? this.form.single_prices.prices.vatRate.value
                        : null;
                if (variables.vatRate === 0) {
                    variables.vatType = this.form.single_prices.prices.vatType;
                }
            }
        } else {
            variables.netAmountSigned = -localDoc.grossAmountSigned;
            variables.netAmount = localDoc.grossAmount;
        }

        const docResult = await this.$apollo.mutate({
            mutation: UPDATE_DOCUMENT_MUTATION,
            variables: variables,
        });

        if (docResult) {
            try {
                await this.createUserActivity(this.document.id, "UPDATE"); // "VALIDATE"
            } catch (e) {
                console.error(e);
            }
        }

        this.updating = false;
        this.loading = false;
        this.validated = true;
        this.spreadPurchaseDialog = false;

        const store_documentParams = this.$store.state?.documentFilter ?? {};
        if (store_documentParams?.switchToNextNoValidatedDocumentAfterValidation) {
            const nextDocumentId = await getNextNoValidatedDocumentId(
                this.$apollo,
                this.getWhere(),
            );
            if (nextDocumentId?.length) {
                if (nextDocumentId === "_") {
                    this.lastDocumentValidationDone = true;
                } else {
                    this.prevNext.nextId = nextDocumentId;
                    this.next();
                }
            }
        }

        if (!this.lastDocumentValidationDone) {
            this.startToBeDoneIfNecessary(); // /!\ refactoring may be necessary with this function
        }
    }

    @Apollo({
        query: CHECK_DOUBLON_DOCUMENT,
        variables() {
            return {
                companyId: this.companyId,
                documentId: this.document.id,
                type: this.document.type,
                date: this.toUpdateDate,
                grossAmountSigned: this.grossAmountSigned,
                thirdPartyCompanyName: this.document?.thirdPartyCompany?.name,
            };
        },
        skip() {
            return !this.enableCheckDoublon;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data && data.checkDoublonDocument) {
                    this.dbDoublonCount = data.checkDoublonDocument.count;
                } else {
                    this.dbDoublonCount = 0;
                }
            }
        },
    })
    dbDoublonCount: number = 0;

    get enableCheckDoublon() {
        if (!this.companyId || !this.document?.id || !this.toUpdateDate) {
            return false;
        }
        if (this.document?.type !== "SALES_INVOICE" && this.document?.type !== "PURCHASE_INVOICE") {
            return false;
        }
        if (!this.grossAmountSigned) {
            return false;
        }
        if (!this.document?.thirdPartyCompany?.name) {
            return false;
        }
        return true;
    }

    get doublonCount() {
        if (this.enableCheckDoublon) {
            return this.dbDoublonCount;
        }
        return 0;
    }

    get doublonLoading() {
        if (this.$apollo.queries.checkDoublonDocument) {
            return this.$apollo.queries.checkDoublonDocument.loading;
        }
        return false;
    }
    //
    // Spread
    //

    spreadPurchaseDialog: boolean = false;
    spreadValid: boolean = false;
    spreadMinStartDate: string = "";
    spreadMaxStartDate: string = "";
    //
    activateSpreadAmount: boolean = false;
    spreadStartDate: string = "";
    spreadMounthCount: number = 2;

    // get spreadMounthCountRules() {
    //     return [
    //         v => !this.activateSpreadAmount || v >= 2 || "Au moins 2 mois",
    //         v => !this.activateSpreadAmount || v <= 12 || "Pas plus de 12 mois"
    //     ];
    // }

    async onSpreadStartDateChanged(date) {
        this.spreadStartDate = date;
    }

    async spreadAmount() {
        await this.onFormValidation();
        this.spreadPurchaseDialog = false;
    }

    convertVATs(document) {
        if (document.data && document.data.subAmounts) {
            for (const subAmountData of document.data.subAmounts) {
                this.addSubAmount(document, subAmountData);
            }
        } else {
            if (document.type === "SALES_INVOICE") {
                for (let index = 1; index <= 3; index++) {
                    let accountableAccountName = document.accountableAccount
                        ? document.accountableAccount.name
                        : this.defaultAccountableAccount;
                    if (
                        document.data &&
                        document.data.subNetAmounts &&
                        index - 1 < document.data.subNetAmounts.length
                    ) {
                        const subNetAmount = document.data.subNetAmounts[index - 1];
                        if (subNetAmount) {
                            accountableAccountName = subNetAmount.accountableAccountName
                                ? subNetAmount.accountableAccountName.name
                                    ? subNetAmount.accountableAccountName.name
                                    : subNetAmount.accountableAccountName
                                : subNetAmount.accountableAccount.name;
                        }
                    }
                    this.convertMultiVAT(document, index, accountableAccountName);
                }
            } else {
                for (let index = 1; index <= 3; index++) {
                    let accountableAccountName = document.accountableAccount
                        ? document.accountableAccount.name
                        : this.defaultAccountableAccount;

                    this.convertMultiVAT(document, index, accountableAccountName);
                }
                if (document?.data?.subNetAmounts?.length) {
                    let vatRate;
                    let vatType;
                    if (this.form.subAmounts.length) {
                        vatRate = "custom";
                        vatType = null;
                        this.form.subAmounts = [];
                    } else {
                        vatRate = document.vatRate === null ? document.vatRate : "custom";
                        vatType = document.vatType;
                    }
                    if (!this.form.subAmounts.length) {
                        const subAmounts = [];
                        for (const subNetAmount of document.data.subNetAmounts) {
                            const ratio =
                                Math.abs(subNetAmount.netAmountSigned) / document.netAmount;
                            const subAmount = {
                                link: true,
                                accountableAccount: subNetAmount.accountableAccountName
                                    ? subNetAmount.accountableAccountName.name
                                        ? subNetAmount.accountableAccountName.name
                                        : subNetAmount.accountableAccountName
                                    : subNetAmount.accountableAccount.name,
                                netAmountSigned: subNetAmount.netAmountSigned,
                                vatAmountSigned: document.vatAmount * ratio,
                                vatRate: vatRate,
                                vatType: vatType,
                            };
                            // this.addSubAmount(document, subAmount)
                            subAmounts.push(subAmount);
                        }
                        let lastVatAmount = document.vatAmount;
                        for (let i = 0; i < subAmounts.length; i++) {
                            const subAmountData = subAmounts[i];
                            if (i + 1 < subAmounts.length) {
                                subAmountData.vatAmountSigned = mathFix(
                                    Math.abs(subAmountData.vatAmountSigned),
                                );
                                lastVatAmount -= subAmountData.vatAmountSigned;
                            } else {
                                subAmountData.vatAmountSigned = mathFix(lastVatAmount);
                            }
                            this.addSubAmount(document, subAmountData);
                        }
                        document.multiVat = true;
                    }
                }
            }
        }

        if (document.data?.subNetAmounts) {
            delete document.data.subNetAmounts;
        }

        this.updateMultiAccountableAccount();
    }

    convertMultiVAT(document, index, accountableAccountName) {
        const suffix = index.toString();
        if (
            document["netAmount" + suffix] ||
            document["vatAmount" + suffix] ||
            document["grossAmount" + suffix]
        ) {
            const sa = {
                suffix,
                link: true,
                accountableAccount: { name: accountableAccountName },
                netAmount: this.buildMetadata(document, "netAmount" + suffix),
                vatAmount: this.buildMetadata(document, "vatAmount" + suffix),
                grossAmount: this.buildMetadata(document, "grossAmount" + suffix),
                vatRate: this.buildMetadata(document, "vatRate" + suffix),
                vatType: null,
                stockOperation: null,
            };
            if (sa.vatRate.value === 0 && document.vatType) {
                sa.vatType = document.vatType;
            }
            this.form.subAmounts.push(sa);
        }
    }

    get defaultAccountableAccount() {
        if (this.inDocument.accountableAccount) {
            return this.document.accountableAccount.name;
        }
        if (this.inDocument.type === "SALES_INVOICE") {
            return "700000";
        }
        return "600000";
    }

    addNewSubGrossAmount() {
        if (!this.document?.type) {
            debugger;
        }
        let accountableAccount = null;
        if (this.document.type === "PURCHASE_INVOICE") {
            accountableAccount = { name: "401000", description: "Fournisseurs" };
        } else if (this.document.type === "SALES_INVOICE") {
            accountableAccount = { name: "411000", description: "Clients" };
        } else if (this.document.type === "CURRENT_ACCOUNT") {
            accountableAccount = { name: "455000", description: "Compte courant" }; // comptes courants
        } else if (this.document.type === "OPERATOR_ACCOUNT") {
            accountableAccount = { name: "108000", description: "Compte de l'exploitant" }; // comptes exploitant
        } else if (this.document.type === "EXPENSE_REPORT") {
            accountableAccount = { name: "425000", description: "Personnel avances et acomptes" }; // note de frais
        } else {
            debugger;
            accountableAccount = { name: "471000", description: "Compte d'attente" };
        }
        if (!this.form.subGrossAmounts) {
            debugger;
            this.form.subGrossAmounts = [];
        }
        this.form.subGrossAmounts.push({
            accountableAccount,
            amount: 0,
            dueDate: null,
        });
    }

    removeSubGrossAmount(index) {
        this.form.subGrossAmounts.splice(index, 1);
    }

    addNewSubAmount() {
        let accountableAccount = this.defaultAccountableAccount;
        this.form.subAmounts.push({
            link: true,
            accountableAccount: { name: accountableAccount },
            netAmount: this.buildMetadataWithValue(0),
            vatAmount: this.buildMetadataWithValue(0),
            grossAmount: this.buildMetadataWithValue(0),
            vatRate: this.subjectToVAT
                ? this.buildMetadataWithValue(20)
                : this.buildMetadataWithValue(0),
            vatType: null,
            stockOperation: null,
            // type: type || null
        });
        this.updateMultiAccountableAccount();
        this.computeTotalFields();
    }

    removeSubAmount(index) {
        if (index >= 0 && index < this.form.subAmounts.length) {
            this.form.subAmounts.splice(index, 1);
        }
        this.updateMultiAccountableAccount();
        this.computeTotalFields();
    }

    addSubAmount(document, subAmountData) {
        let grossAmountSigned = subAmountData.grossAmountSigned;
        if (!grossAmountSigned) {
            if (subAmountData.vatAmountSigned) {
                grossAmountSigned = subAmountData.netAmountSigned + subAmountData.vatAmountSigned;
            } else {
                grossAmountSigned = subAmountData.netAmountSigned;
                subAmountData.vatAmountSigned = 0;
                subAmountData.vatRate = "custom";
                subAmountData.vatType = null;
            }
        }
        const vatRate =
            subAmountData.vatRate === undefined ||
            subAmountData.vatRate === null ||
            subAmountData.vatRate === "custom"
                ? "custom"
                : Math.abs(subAmountData.vatRate);
        if (subAmountData.stockOperation) {
            this.updateStockOperation(this.document, subAmountData.stockOperation);
        }
        this.form.subAmounts.push({
            accountableAccount: {
                name: subAmountData.accountableAccount || this.defaultAccountableAccount,
            },
            link: subAmountData.link !== undefined ? subAmountData.link : true,
            netAmount: subAmountData.index
                ? this.buildMetadata(
                      document,
                      "netAmount" + subAmountData.index,
                      "number",
                      Math.abs(subAmountData.netAmountSigned),
                  )
                : this.buildMetadataWithValue(Math.abs(subAmountData.netAmountSigned)),
            vatAmount: subAmountData.index
                ? this.buildMetadata(
                      document,
                      "vatAmount" + subAmountData.index,
                      "number",
                      Math.abs(subAmountData.vatAmountSigned),
                  )
                : this.buildMetadataWithValue(Math.abs(subAmountData.vatAmountSigned)),
            grossAmount: subAmountData.index
                ? this.buildMetadata(
                      document,
                      "grossAmount" + subAmountData.index,
                      "number",
                      Math.abs(grossAmountSigned),
                  )
                : this.buildMetadataWithValue(Math.abs(grossAmountSigned)),
            vatRate: subAmountData.index
                ? this.buildMetadata(document, "vatRate" + subAmountData.index, "number", vatRate)
                : this.buildMetadataWithValue(vatRate),
            vatType: subAmountData.vatType !== undefined ? subAmountData.vatType : null,
            sign: subAmountData.sign !== undefined ? subAmountData.sign : null,
            // sign: subAmountData.sign !== undefined ? subAmountData.sign : subAmountData.netAmountSigned < 0 ? 1 : -1,
            stockOperation: subAmountData.stockOperation,
        });
    }

    updateStockOperation(document, stockOperation) {
        if (!document.accountingLines?.length || !stockOperation) {
            return;
        }
        const al = document.accountingLines.find(
            (al) =>
                al.stockOperation &&
                al.stockOperation?.stockProduct?.id === stockOperation.stockProductId,
        );
        stockOperation.tagId = al?.stockOperation?.stockProduct?.tag?.id || null;
        stockOperation.unitQuantity = al?.stockOperation?.stockProduct?.unitQuantity;

        if (!stockOperation.data) {
            stockOperation.data = {};
        }
        if (al.stockOperation.stockProduct?.data?.quantities?.length) {
            const quantities = al.stockOperation.stockProduct.data.quantities.map((q) => ({
                quantityName: q.quantityName,
                quantity: 0,
            }));
            if (stockOperation.data.quantities) {
                for (let i = 0; i < quantities.length; i++) {
                    if (stockOperation.data.quantities[i]?.quantity) {
                        quantities[i].quantity = stockOperation.data.quantities[i].quantity;
                    }
                }
            }
            stockOperation.data["quantities"] = quantities;
        }
    }

    //
    //
    //
    updateForm(document: any) {
        this.document = document;
        this.dueDate = document.dueDate || document.date || document.dateAuto || "";
        if (this.dueDate) {
            if (!moment(this.dueDate).isValid()) {
                this.dueDate = "";
            } else {
                this.dueDate = moment(this.dueDate).format("YYYY-MM-DD");
            }
        }
        this.updateCurrentAccountUser();
        // if (this.inDocument.owner) {
        //     this.currentAccountUser = this.inDocument.owner;
        // } else {
        //     this.currentAccountUser = this.defaultUser;
        // }
        if (this.document.status.startsWith("ANALYSED")) {
            this.validated = false;
        } else {
            this.validated = true;
        }

        if (this.document.data?.stockOperation) {
            this.updateStockOperation(this.document, this.document.data.stockOperation);
            this.stockOperation = this.document.data.stockOperation;
        }

        if (
            this.document.data &&
            this.document.data.deposit &&
            (this.document.data.deposit.amountSigned1 || this.document.data.deposit.amountSigned2)
        ) {
            this.withDeposit = true;
            this.deposit = this.document.data.deposit;
            const sign = getAmountSign(this.document);
            if (this.deposit.amountSigned1) {
                this.document.grossAmountSigned += this.deposit.amountSigned1;
                this.deposit.amountSigned1 = sign * this.deposit.amountSigned1;
            }
            if (this.deposit.amountSigned2) {
                this.document.grossAmountSigned += this.deposit.amountSigned2;
                this.deposit.amountSigned2 = sign * this.deposit.amountSigned2;
            }
            this.document.grossAmount = Math.abs(this.document.grossAmountSigned);
        } else {
            this.withDeposit = false;
            this.deposit = {
                amountSigned1: 0,
                amountSigned2: 0,
            };
        }

        if (document.type === "PURCHASE_INVOICE") {
            if (document.data && document.data.spreading) {
                this.spreadStartDate = document.data.spreading.startDate;
                this.spreadMounthCount = document.data.spreading.mounthCount;
                if (this.spreadStartDate && this.spreadMounthCount) {
                    this.activateSpreadAmount = true;
                } else {
                    this.activateSpreadAmount = false;
                    this.spreadMounthCount = 0;
                }
            } else {
                this.activateSpreadAmount = false;
                this.spreadMounthCount = 0;
            }
        } else {
            this.activateSpreadAmount = false;
            this.spreadMounthCount = 2;
            this.spreadStartDate = "";
        }
        // this.loadSubNetAmounts(document)

        document.variants = [];
        if (this.analysis && this.analysis.values) {
            this.analysis.values.forEach((variant) => {
                const coordinates: any = [];
                if (variant.boxes.length > 0) {
                    variant.boxes.forEach((box) => {
                        if (box.vertices.length > 0) coordinates.push(box.vertices);
                    });
                }
                document.variants.push({
                    value: variant.value,
                    type: variant.type,
                    coordinates: coordinates,
                });
            });
        }

        this.computeSVGVariants(document);

        if (!document.invoiceNumber && document.type !== "SALES_INVOICE") {
            document.invoiceNumber = "";
        }
        this.form = {
            date: this.buildMetadata(document, "date", "date"),
            invoiceNumber: this.buildMetadata(document, "invoiceNumber", "string"),
            allPricesValidated: this.document.status === "VALIDATED",
            single_prices: {
                prices: {
                    link: true,
                    total: true,
                    vatAmount: this.buildMetadata(document, "vatAmount"),
                    netAmount: this.buildMetadata(document, "netAmount"),
                    grossAmount: this.buildMetadata(document, "grossAmount"),
                    vatRate: this.buildMetadata(document, "vatRate"),
                    vatType: document.vatType,
                },
            },
            subAmounts: [],
            subGrossAmounts: [],
        };

        this.convertVATs(document);
        this.loadSubGrossAmounts(document);

        if (
            !this.form.single_prices.prices.vatRate.value ||
            !this.form.single_prices.prices.netAmount.value ||
            !this.form.single_prices.prices.grossAmount.value ||
            !this.form.single_prices.prices.vatAmount.value
        ) {
            if (
                this.form.single_prices.prices.vatRate.value !== null &&
                this.form.single_prices.prices.vatRate.value !== "custom"
            ) {
                this.onMetadataChange_amountData(this.form.single_prices.prices, "vatRate");
            } else if (this.form.single_prices.prices.netAmount.value !== null) {
                this.onMetadataChange_amountData(this.form.single_prices.prices, "netAmount");
            } else if (this.form.single_prices.prices.grossAmount.value !== null) {
                this.onMetadataChange_amountData(this.form.single_prices.prices, "grossAmount");
            } else if (this.form.single_prices.prices.vatAmount.value !== null) {
                this.onMetadataChange_amountData(this.form.single_prices.prices, "vatAmount");
            }
        }
    }

    loadSubGrossAmounts(document) {
        if (document?.data?.subGrossAmounts) {
            document.data.subGrossAmounts.forEach((subGrossAmount) => {
                this.form.subGrossAmounts.push({
                    amount: Math.abs(subGrossAmount.amount),
                    accountableAccount: { name: subGrossAmount.accountableAccount },
                    dueDate: subGrossAmount.dueDate,
                });
            });
        }
        this.withSubGrossAmounts = !!this.form.subGrossAmounts.length;
    }

    getFieldSync(type) {
        // deprecated user subAmount.link instead
        debugger;
    }

    onSelectChange(eventValue: any, priceType: any, suffix, key: string) {
        // deprecated use onVatRateChange instead
        debugger;
    }

    onVatRateChange(amountData, eventValue) {
        if (eventValue !== null) {
            if (typeof eventValue === "string") {
                if (eventValue === "custom") {
                    amountData.vatType = null;
                    amountData.vatRate.value = "custom";
                    amountData.link = false;
                } else if (eventValue.startsWith("0") && eventValue.length > 1) {
                    amountData.vatType = eventValue.substr(1);
                    amountData.vatRate.value = 0;
                } else {
                    amountData.vatType = null;
                    amountData.vatRate.value = parseFloat(eventValue);
                }
            } else {
                debugger;
                // amountData.vatType = null
                // amountData.vatRate.value = eventValue
            }
        }
        this.onMetadataChange_amountData(amountData, "vatRate");
    }

    checkValueAndVariant(key, valueData) {
        this.cleanVariant(valueData);
        let conf: any = 0;
        const index = this.svgVariants.findIndex((variant) => {
            if (
                variant.fieldNames.some((el) => {
                    conf = el.confidence;
                    return el.name === key;
                }) &&
                !variant.active
            ) {
                return (
                    variant.value == valueData.value // do not modify
                );
            }
            return false;
        });
        if (index >= 0) {
            this.svgVariants[index].active = true;
            this.svgVariants[index].focus = false;
            valueData.index = index;
            valueData.confidence = conf;
        } else {
            valueData.index = null;
            valueData.confidence = null;
        }
    }

    @Watch("form", { deep: true })
    onFormUpdate(current: any) {
        // console.log("on form updateeee");
        let index = null;
        Object.keys(current).forEach((k) => {
            if (k !== "allPricesValidated") {
                if (["single_prices"].includes(k)) {
                    Object.keys(current[k]).forEach((k2: any) => {
                        this.checkValueAndVariant("netAmount", current[k][k2].netAmount);
                        this.checkValueAndVariant("vatAmount", current[k][k2].vatAmount);
                        this.checkValueAndVariant("grossAmount", current[k][k2].grossAmount);
                        this.checkValueAndVariant("vateRate", current[k][k2].vatRate);
                        // Object.keys(current[k][k2]).forEach((k3: any) => {
                        //     this.checkValueAndVariant(k3, current[k][k2][k3])
                        // });
                    });
                } else if (k === "subAmounts") {
                    for (const subAmountData of current.subAmounts) {
                        if (subAmountData.index) {
                            this.checkValueAndVariant(
                                "netAmount" + subAmountData.index,
                                subAmountData.netAmount,
                            );
                            this.checkValueAndVariant(
                                "vatAmount" + subAmountData.index,
                                subAmountData.vatAmount,
                            );
                            this.checkValueAndVariant(
                                "grossAmount" + subAmountData.index,
                                subAmountData.grossAmount,
                            );
                            this.checkValueAndVariant(
                                "vateRate" + subAmountData.index,
                                subAmountData.vatRate,
                            );
                        }
                    }
                } else if (k !== "subGrossAmounts") {
                    this.checkValueAndVariant(k, current[k]);
                }
            }
        });
        this.$forceUpdate();
    }

    onMetadataChange(priceType: any, suffix: string, propertyName: string) {
        // deprecated use onMetadataChange_amountData instead
        debugger;
    }

    onMetadataChange_amountData(amountData, propertyName) {
        // debugger;
        if (this.multiAccountableAccount && !this.multiVat && !amountData.total) {
            amountData.netAmount.validated = !!amountData.netAmount.value;
            amountData.vatAmount.value = 0;
            amountData.vatAmount.validated = true;
            amountData.grossAmount.value = amountData.netAmount.value;
            amountData.grossAmount.validated = amountData.netAmount.validated;
            amountData.vatRate.value = 0;
            amountData.vatRate.validated = amountData.netAmount.validated;
            amountData.vatType = "NO_VAT_TYPE";
            this.computeTotalFields();
            return;
        }
        if (!amountData.link || amountData.vatRate.value === "custom") {
            if (!amountData.total && (this.multiVat || this.multiAccountableAccount)) {
                this.computeTotalFields();
            }
            return null;
        }
        // console.log("on meta change");
        // const groupedNames = {
        //     vatAmount: "vatAmount",
        //     netAmount: "netAmount",
        //     grossAmount: "grossAmount",
        //     vatRate: "vatRate"
        // };
        switch (propertyName) {
            case "vatRate":
                // if (amountData.vatRate.value !== "custom") {
                if (this.multiAccountableAccount && !this.multiVat) {
                    if (
                        amountData.netAmount.value !== null &&
                        amountData.netAmount.value !== undefined
                    ) {
                        amountData.vatAmount.value = mathFix(
                            amountData.netAmount.value * (amountData.vatRate.value / 100),
                        );
                        amountData.grossAmount.value = mathFix(
                            amountData.vatAmount.value + amountData.netAmount.value,
                        );
                    } else if (
                        amountData.grossAmount.value !== null &&
                        amountData.grossAmount.value !== undefined
                    ) {
                        amountData.netAmount.value = mathFix(
                            amountData.grossAmount.value / (1 + amountData.vatRate.value / 100),
                        );
                        amountData.vatAmount.value = mathFix(
                            amountData.grossAmount.value - amountData.netAmount.value,
                        );
                    }
                } else if (
                    amountData.grossAmount.value !== null &&
                    amountData.grossAmount.value !== undefined
                ) {
                    amountData.netAmount.value = mathFix(
                        amountData.grossAmount.value / (1 + amountData.vatRate.value / 100),
                    );
                    amountData.vatAmount.value = mathFix(
                        amountData.grossAmount.value - amountData.netAmount.value,
                    );
                } else if (
                    amountData.netAmount.value !== null &&
                    amountData.netAmount.value !== undefined
                ) {
                    amountData.vatAmount.value = mathFix(
                        amountData.netAmount.value * (amountData.vatRate.value / 100),
                    );
                    amountData.grossAmount.value = mathFix(
                        amountData.vatAmount.value + amountData.netAmount.value,
                    );
                }
                // }
                break;
            case "netAmount":
                if (this.subjectToVAT) {
                    if (
                        amountData.vatRate.value !== undefined &&
                        amountData.vatRate.value !== null
                    ) {
                        // if (amountData.vatRate.value !== "custom") {
                        if (amountData.vatRate.value) {
                            amountData.vatAmount.value = mathFix(
                                amountData.netAmount.value * (amountData.vatRate.value / 100),
                            );
                            amountData.grossAmount.value = mathFix(
                                amountData.vatAmount.value + amountData.netAmount.value,
                            );
                        } else {
                            amountData.vatAmount.value = 0;
                            amountData.grossAmount.value = amountData.netAmount.value;
                        }
                        // } else if (amountData.grossAmount.value !== null && amountData.grossAmount.value !== undefined) {
                        //     amountData.vatAmount.value = mathFix(amountData.grossAmount.value - amountData.netAmount.value)
                        // } else if (amountData.vatAmount.value !== null && amountData.vatAmount.value !== undefined) {
                        //     amountData.grossAmount.value = mathFix(amountData.netAmount.value + amountData.vatAmount.value)
                        // }
                    }
                } else {
                    amountData.vatAmount.value = 0;
                    amountData.grossAmount.value = amountData.netAmount.value;
                }
                break;
            case "vatAmount":
                if (amountData.vatRate.value !== undefined && amountData.vatRate.value !== null) {
                    // if (amountData.vatRate.value !== "custom") {
                    if (amountData.vatRate.value) {
                        amountData.netAmount.value = mathFix(
                            (100 * amountData.vatAmount.value) / amountData.vatRate.value,
                        );
                        amountData.grossAmount.value = mathFix(
                            amountData.netAmount.value + amountData.vatAmount.value,
                        );
                    } else {
                        amountData.vatAmount.value = 0;
                    }
                    // } else if (amountData.grossAmount.value !== null && amountData.grossAmount.value !== undefined) {
                    //     amountData.netAmount.value = mathFix(amountData.grossAmount.value - amountData.vatAmount.value)
                    // } else if (amountData.netAmount.value !== null && amountData.netAmount.value !== undefined) {
                    //     amountData.grossAmount.value = mathFix(amountData.netAmount.value + amountData.vatAmount.value)
                    // }
                }
                break;
            case "grossAmount":
                if (amountData.vatRate.value !== undefined && amountData.vatRate.value !== null) {
                    // if (amountData.vatRate.value !== "custom") {
                    if (amountData.vatRate.value) {
                        amountData.netAmount.value = mathFix(
                            amountData.grossAmount.value / (1.0 + amountData.vatRate.value / 100),
                        );
                        amountData.vatAmount.value = mathFix(
                            amountData.grossAmount.value - amountData.netAmount.value,
                        );
                        // this.form.allPricesValidated = true
                    } else {
                        amountData.vatAmount.value = 0;
                        amountData.netAmount.value = amountData.grossAmount.value;
                    }
                    // } else if (amountData.netAmount.value !== null && amountData.netAmount !== undefined) {
                    //     amountData.vatAmount.value = mathFix(amountData.grossAmount.value - amountData.netAmount.value)
                    // } else if (amountData.vatAmount.value !== null && amountData.vatAmount.value !== undefined) {
                    //     amountData.netAmount.value = mathFix(amountData.grossAmount.value - amountData.vatAmount.value)
                    // }
                }
                break;
            default:
        }
        if (
            !(this.multiAccountableAccount && !this.multiVat && amountData.total && "grossAmount")
        ) {
            this.computeTotalFields();
        }
        return null;
    }

    computeTotalFields() {
        if (!this.multiVat && !this.multiAccountableAccount) {
            return;
        }
        const totalFields = this.form.single_prices.prices;

        const totals = {
            netAmount: 0,
            vatAmount: 0,
            grossAmount: 0,
        };
        this.form.subAmounts.forEach((subAmountData, index) => {
            if (!this.multiVat && this.multiAccountableAccount) {
                if (index === 0) {
                    subAmountData.grossAmount.value = mathFix(totalFields.netAmount.value);
                    subAmountData.vatAmount.value = mathFix(totalFields.vatAmount.value);

                    subAmountData.grossAmount.validated = true;
                    subAmountData.netAmount.validated = true;
                    subAmountData.vatAmount.validated = true;
                    subAmountData.vatRate.validated = true;
                } else {
                    subAmountData.grossAmount.value = 0;
                    subAmountData.vatAmount.value = 0;

                    subAmountData.grossAmount.validated = true;
                    subAmountData.netAmount.validated = true;
                    subAmountData.vatAmount.validated = true;
                    subAmountData.vatRate.validated = true;
                }
            }
            let sign = 1;
            if (subAmountData.sign === -1) {
                sign = -1;
            }
            if (subAmountData.netAmount.value)
                totals.netAmount += sign * subAmountData.netAmount.value;
            if (subAmountData.vatAmount.value)
                totals.vatAmount += sign * subAmountData.vatAmount.value;
            if (subAmountData.grossAmount.value)
                totals.grossAmount += sign * subAmountData.grossAmount.value;
        });

        totalFields.netAmount.value = mathFix(totals.netAmount);
        totalFields.netAmount.validated = false;
        if (this.multiAccountableAccount && !this.multiVat) {
            totalFields.netAmount.validated = true;
            this.onMetadataChange_amountData(totalFields, "netAmount");
        } else {
            totalFields.vatAmount.value = mathFix(totals.vatAmount);
            totalFields.vatAmount.validated = false;

            totalFields.grossAmount.value = mathFix(totals.grossAmount);
            totalFields.grossAmount.validated = false;
        }

        totalFields.vatRate.validated = false;
    }

    //
    // wizard
    //
    wizardStep = 1;
    // historic = [0];

    get wizardStepTitle() {
        switch (this.wizardStep) {
            case 1:
                return "Cette facture correspond à";
            case 2:
                return "S'agit-il d'un avoir ?";
            case 3:
                if (this.document.type === "SALES_INVOICE") {
                    return "Choisissez le client";
                }
                return "Choisissez le fournisseur";
            case 4:
                if (!this.form.date || !this.form.date.value) {
                    return "Choisissez la date de la facture";
                }
                return "Validez la date de la facture";
            case 5:
                if (!this.document.dueDate) return "Choisir une date d'échéance";
                return "Validez la date d'échéance";
            case 6:
                if (this.subjectToVAT) return "Valider les montants";
                return "Validez le montant";
            case 7:
                return "Choisissez le type de tva";
            case 8:
                return "Choisissez l'associé";
            case 9:
                return "Validez le numéro de facture";
        }
        return "Title" + this.wizardStep;
    }

    disabledPrevStep() {
        if (this.wizardStep === 1) return true;
        if (this.wizardStep === 3 && this.document.type === "EXPENSE_REPORT_DOCUMENT") return true;
        return false;
    }

    disabledNextStep() {
        switch (this.wizardStep) {
            case 1:
                return false;
            case 2: // avoir
                return false;
            case 3: // client / fournisseur
                if (!this.document.thirdPartyCompany) return true;
                return false;
            case 4: // date
                if (!this.form.date || !this.form.date.value) return true;
                return false;
            case 5: // date d'échéance
                if (!this.dueDate) return true;
                return false;
            case 6: // validation des montants
                if (!this.arePricesValidated) return true;
                return false;
            case 7: // vat type
                if (!this.document.vatType) return true;
                return false;
            case 8: // user
                return false;
        }
        return false;
    }

    nextStep() {
        switch (this.wizardStep) {
            case 1: // type de documment
                if (
                    this.document.type === "PURCHASE_INVOICE" ||
                    this.document.type === "SALES_INVOICE"
                ) {
                    this.wizardStep++;
                } else {
                    this.wizardStep = 8; // user
                }
                break;
            case 2: // avoir
                this.wizardStep++;
                break;
            case 3: // client / fournisseur
                if (this.document.type === "SALES_INVOICE") {
                    this.wizardStep = 9;
                } else {
                    this.wizardStep++;
                }
                break;
            case 4: // date
                if (this.document.type === "SALES_INVOICE") {
                    this.wizardStep++;
                } else {
                    // pas de date d'échéance
                    this.wizardStep = 6;
                }
                break;
            case 5: // date d'échéance
                this.wizardStep++;
                break;
            case 6: // validation des montants
                if (this.showVATType()) {
                    this.wizardStep++;
                } else {
                    this.onFormValidation();
                }
                break;
            case 7: // vat type
                this.onFormValidation();
                break;
            case 8: // user
                this.wizardStep = 3;
                break;
            case 9: // invoiceNumber
                this.wizardStep = 4;
                break;
        }
    }

    previousStep() {
        switch (this.wizardStep) {
            case 1:
                // this.wizardStep++;
                break;
            case 2: // avoir
                this.wizardStep--;
                break;
            case 3: // client / fournisseur
                if (this.document.type !== "EXPENSE_REPORT_DOCUMENT") {
                    if (
                        this.document.type === "PURCHASE_INVOICE" ||
                        this.document.type === "SALES_INVOICE"
                    ) {
                        this.wizardStep--;
                    } else {
                        // pas de validation pour l'avoir
                        this.wizardStep = 8;
                    }
                }
                break;
            case 4: // date
                if (this.document.type === "SALES_INVOICE") {
                    this.wizardStep = 9;
                } else {
                    this.wizardStep--;
                }
                break;
            case 5: // date d'échéance
                this.wizardStep--;
                break;
            case 6: // validation des montants
                if (this.document.type === "SALES_INVOICE") {
                    this.wizardStep--;
                } else {
                    // pas de date d'échéance
                    this.wizardStep = 4;
                }
                break;
            case 7: // vat type
                this.wizardStep--;
                break;
            case 8: // user
                this.wizardStep = 1;
                break;
            case 9: // invoice number
                this.wizardStep = 3;
                break;
        }
    }

    get otherThirdPartyCompany() {
        if (this.document.type === "SALES_INVOICE") {
            if (this.document.thirdPartyCompany) {
                return "Je choisis un autre client";
            }
            return "Je choisis le client";
        }
        if (this.document.thirdPartyCompany) {
            return "Je choisis un autre fournisseur";
        }
        return "Je choisis le fournisseur";
    }

    get documentTypeItems() {
        const documentTypes = [
            {
                type: "SALES_INVOICE",
                title: "Facture de vente",
                icon: "trending_up",
                iconClass: "secondary white--text",
            },
            {
                type: "PURCHASE_INVOICE",
                title: "Facture d'achat",
                icon: "trending_down",
                iconClass: "new_red white--text",
            },
        ];
        if (this.legalForm !== "EI") {
            documentTypes.push({
                type: "CURRENT_ACCOUNT",
                title: "Achat avancé par un associé",
                icon: "trending_down",
                iconClass: "new_red white--text",
            });
        } else {
            documentTypes.push({
                type: "OPERATOR_ACCOUNT",
                title: "Achat avancé par un exploitant",
                icon: "trending_down",
                iconClass: "new_red white--text",
            });
        }
        return documentTypes;
    }

    geDocumentTypeClass(documentType) {
        let docClass = "mb-2 oss-list-item";
        if (this.$vuetify.display.mobile) {
            docClass += " px-2";
        }
        if (documentType === this.document.type) {
            docClass += " oss-list-item-selected";
        }
        return docClass;
    }

    onUserSelected(user) {
        this.currentAccountUser = user;
    }

    async setToReuploadDocument() {
        await this.$apollo.mutate({
            mutation: gql`
                mutation setToReuploadDocument($documentId: ID!) {
                    updateDocument(where: { id: $documentId }, data: { status: PENDING }) {
                        id
                    }
                }
            `,
            variables: {
                documentId: this.document.id,
            },
        });
        this.document.status = "PENDING";
        try {
            await this.createUserActivity(this.document.id, "UPDATE");
        } catch (e) {
            console.error(e);
        }
    }
}
